"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4479],{

/***/ 43708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11355);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99545);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var Alert = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, Message = param.Message;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.overflow = "auto";
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition */ .u, {
            appear: true,
            show: isOpen,
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Dialog */ .V, {
                as: "div",
                className: "relative z-[9999999]",
                onClose: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 bg-black/50 overflow-y-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Transition.Child */ .u.Child, {
                            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Dialog.Panel */ .V.Panel, {
                                className: "w-full max-w-md rounded transform overflow-hidden bg-white p-10 text-left align-middle shadow-xl transition-all",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__/* .Dialog.Title */ .V.Title, {
                                    className: "text-lg  ".concat(Message.code === 200 ? "text-green-600" : "text-red-600", " text-center"),
                                    children: Message.message
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Alert);


/***/ }),

/***/ 79401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _isRtl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62009);
/* eslint-disable @typescript-eslint/no-explicit-any */ 


// Utility to safely resolve dot notation access
var getValueByAccessor = function(obj, accessor) {
    return accessor.split(".").reduce(function(acc, key) {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
};
var ButtonGroup = function(param) {
    var items = param.items, selectedIndex = param.selectedIndex, onSelect = param.onSelect, labelAccessor = param.labelAccessor, _className = param.className, className = _className === void 0 ? "" : _className;
    if (!items || items.length === 0) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-wrap ".concat(className),
        children: items.map(function(item, index) {
            var label = getValueByAccessor(item, labelAccessor);
            if (!label) return null;
            var isSelected = selectedIndex === index;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: function() {
                    return onSelect(index);
                },
                className: "animate-top-dga dga-primary-button !rounded-none\n              ".concat(isSelected ? "!text-white !bg-neutral-950" : "!text-primary-1000 !bg-neutral-100 hover:!bg-neutral-200 active:!bg-neutral-300", "\n              ").concat((0,_isRtl__WEBPACK_IMPORTED_MODULE_2__["default"])() ? "border-r border-r-neutral-300 first:border-r-0 first:!rounded-r-lg last:!rounded-l-lg" : "border-l border-l-neutral-300 first:border-l-0 first:!rounded-l-lg last:!rounded-r-lg", "\n            "),
                children: label
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ButtonGroup));


/***/ }),

/***/ 65961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16606);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21074);
/* harmony import */ var _isRtl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62009);
/* harmony import */ var _dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63651);
/* eslint-disable @typescript-eslint/no-explicit-any */ 













// ChatBot will be loaded dynamically on client-side only
var ChatBot = null;
var ChatHeader = function(param) {
    var toggleChatbot = param.toggleChatbot, header = param.header, online = param.online;
    var getOrdinal = function getOrdinal(day) {
        if (day > 3 && day < 21) return "th";
        switch(day % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var now = new Date();
    var day = now.getDate();
    var month = now.toLocaleString("en-US", {
        month: "long"
    });
    var hour = now.toLocaleString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    });
    var result = "".concat(month, " ").concat(day).concat(getOrdinal(day), " at ").concat(hour);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex px-2 py-4 bg-[#1B8354] justify-between items-center h-lg:p-4 ".concat(locale == "ar" ? "rtl" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-4 items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        width: "44",
                                        height: "44",
                                        viewBox: "0 0 44 44",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M22 1C33.598 1 43 10.402 43 22C43 33.598 33.598 43 22 43C10.402 43 1 33.598 1 22C1 10.402 10.402 1 22 1Z",
                                                fill: "#F3F4F6",
                                                stroke: "white",
                                                strokeWidth: "2"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M11.0181 20.0308C11.3474 14.2515 16.1382 9.6665 22 9.6665C27.8618 9.6665 32.6526 14.2515 32.9819 20.0308C31.851 18.9775 30.3341 18.3332 28.6667 18.3332C26.6416 18.3332 25 19.9748 25 21.9998V27.3332C25 29.3582 26.6416 30.9998 28.6667 30.9998C30.3355 30.9998 31.8536 30.3544 32.9849 29.2995C32.9766 29.631 32.9638 29.9277 32.944 30.1978C32.8893 30.9427 32.7852 31.4074 32.6182 31.7783C32.1837 32.7438 31.4107 33.5169 30.4451 33.9514C30.0742 34.1183 29.6095 34.2224 28.8646 34.2771C28.1098 34.3325 27.1485 34.3332 25.7949 34.3332H22C21.4477 34.3332 21 34.7809 21 35.3332C21 35.8855 21.4477 36.3332 22 36.3332H25.8343C27.1398 36.3332 28.1745 36.3332 29.0111 36.2718C29.8661 36.209 30.5929 36.0781 31.2659 35.7752C32.6771 35.1401 33.8069 34.0103 34.442 32.5991C34.745 31.926 34.8758 31.1993 34.9386 30.3443C35 29.5076 35 28.473 35 27.1675V20.6665C35 13.4868 29.1797 7.6665 22 7.6665C14.8203 7.6665 9 13.4868 9 20.6665V24.6665C9 28.1643 11.8355 30.9998 15.3333 30.9998C17.3584 30.9998 19 29.3582 19 27.3332V21.9998C19 19.9748 17.3584 18.3332 15.3333 18.3332C13.6659 18.3332 12.149 18.9775 11.0181 20.0308ZM11 24.6665C11 27.0597 12.9401 28.9998 15.3333 28.9998C16.2538 28.9998 17 28.2536 17 27.3332V21.9998C17 21.0794 16.2538 20.3332 15.3333 20.3332C12.9401 20.3332 11 22.2733 11 24.6665ZM33 24.6665C33 22.2733 31.0599 20.3332 28.6667 20.3332C27.7462 20.3332 27 21.0794 27 21.9998V27.3332C27 28.2536 27.7462 28.9998 28.6667 28.9998C31.0599 28.9998 33 27.0597 33 24.6665Z",
                                                fill: "#0F2837"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col text-white",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-sm font-bold mb-2",
                                        children: header
                                    }),
                                    online && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center justify-center gap-1 rounded-xl p-1 bg-green-200 w-fit",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[10px] h-[10px] rounded-full bg-green-800"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-green-800 text-[10px] leading-3 ",
                                                    children: online
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                        onClick: toggleChatbot,
                        size: "iconOnly md",
                        variant: "primary",
                        className: "!outline-none !ring-0 !ring-offset-0",
                        "aria-label": "Close chatbot",
                        buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 12 12",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M0.558059 0.558058C0.802136 0.313981 1.19786 0.313981 1.44194 0.558058L6 5.11612L10.5581 0.558059C10.8021 0.313981 11.1979 0.313981 11.4419 0.558059C11.686 0.802136 11.686 1.19786 11.4419 1.44194L6.88388 6L11.4419 10.5581C11.686 10.8021 11.686 11.1979 11.4419 11.4419C11.1979 11.686 10.8021 11.686 10.5581 11.4419L6 6.88388L1.44194 11.4419C1.19786 11.686 0.802136 11.686 0.558058 11.4419C0.313981 11.1979 0.313981 10.8021 0.558058 10.5581L5.11612 6L0.558059 1.44194C0.313981 1.19786 0.313981 0.802136 0.558059 0.558058Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-2 flex justify-center text-[#384250] text-[10px]",
                children: result
            })
        ]
    });
};
var ChatBotComponent = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        Language: "",
        SerivceTitle: [],
        ServiceQuestion: [],
        SessionId: "",
        // Location: "", // Commented out location tracking
        LastStepName: "",
        Rating: null
    }), chatAnalyticsPostBody = ref8[0], setChatAnalyticsPostBody = ref8[1];
    var chatAnalyticsRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(chatAnalyticsPostBody);
    chatAnalyticsRef.current = chatAnalyticsPostBody;
    // useEffect(() => {
    // }, [chatAnalyticsPostBody]);
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), loading = ref9[0], setLoading = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), chatData = ref10[0], setChatData = ref10[1];
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var language = function() {
        var raw = (locale || "en").toString().slice(0, 2).toLowerCase();
        if (raw === "ar" || raw === "en" || raw === "zh" || raw === "ko") return raw;
        return "en";
    }();
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isOpen = ref11[0], setIsOpen = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), chatBotLoaded = ref12[0], setChatBotLoaded = ref12[1];
    var isRtl = (0,_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])();
    // Load ChatBot only on client-side using dynamic import
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if ( true && !ChatBot) {
            // @ts-ignore - react-simple-chatbot doesn't have type definitions
            Promise.all(/* import() */[__webpack_require__.e(2786), __webpack_require__.e(9395), __webpack_require__.e(4718), __webpack_require__.e(2644), __webpack_require__.e(4800)]).then(__webpack_require__.t.bind(__webpack_require__, 36599, 23)).then(function(module) {
                ChatBot = module.default;
                setChatBotLoaded(true);
            }).catch(function() {
                // Handle error silently
                console.error("Failed to load ChatBot");
            });
        }
    }, []);
    var loadData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat("https://c-admin.takamulstg.com", "/api/ChatBot/GetChatBot"), {
                                culture: locale
                            }, {
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        setChatData(response.data);
                        setLoading(false);
                        return [
                            2,
                            response.data
                        ];
                    case 3:
                        error = _state.sent();
                        setLoading(false);
                        console.error("Failed to fetch chatbot data:", error);
                        return [
                            2,
                            null
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function loadData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale
    ]);
    var StarRating = function(param) {
        var triggerNextStep = param.triggerNextStep;
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), selected = ref[0], setSelected = ref[1];
        var stars = [
            "\uD83D\uDE21",
            "\uD83D\uDE15",
            "\uD83D\uDE10",
            "\uD83D\uDE0A",
            "\uD83E\uDD29"
        ];
        var handleRating = function(index) {
            setSelected(index + 1);
            setTimeout(function() {
                triggerNextStep({
                    value: index + 1
                });
            }, 500);
        };
        var renderRating = function(ratingIcon, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    cursor: "pointer",
                    marginRight: "10px",
                    opacity: selected === index + 1 ? 1 : 0.6
                },
                onClick: function() {
                    return handleRating(index);
                },
                children: [
                    !(chatData === null || chatData === void 0 ? void 0 : chatData.showIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: stars[index]
                    }),
                    ratingIcon && (chatData === null || chatData === void 0 ? void 0 : chatData.showIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "inline-block w-[24px] h-[24px] relative",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "https://c-admin.takamulstg.com" + ratingIcon,
                            alt: "rating-icon-".concat(index),
                            layout: "fill"
                        })
                    })
                ]
            });
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: chatData === null || chatData === void 0 ? void 0 : chatData.ratingTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    style: {
                        fontSize: "24px"
                    },
                    children: [
                        renderRating(chatData === null || chatData === void 0 ? void 0 : chatData.firstRatingIcon, 0),
                        renderRating(chatData === null || chatData === void 0 ? void 0 : chatData.secondRatingIcon, 1),
                        renderRating(chatData === null || chatData === void 0 ? void 0 : chatData.thirdRatingIcon, 2),
                        renderRating(chatData === null || chatData === void 0 ? void 0 : chatData.fourthRatingIcon, 3),
                        renderRating(chatData === null || chatData === void 0 ? void 0 : chatData.fifthRatingIcon, 4)
                    ]
                })
            ]
        });
    };
    var content = {
        en: {
            promptText: chatData === null || chatData === void 0 ? void 0 : chatData.promptText,
            welcome: chatData === null || chatData === void 0 ? void 0 : chatData.welcomeText,
            selectOption: chatData === null || chatData === void 0 ? void 0 : chatData.optionsSelectionText,
            otherResponse: (ref1 = (ref = chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories[(chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories.length) - 1]) === null || ref === void 0 ? void 0 : ref.questions[0]) === null || ref1 === void 0 ? void 0 : ref1.description,
            returnPrompt: chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
            fallback: chatData === null || chatData === void 0 ? void 0 : chatData.fallbackText,
            thankYou: chatData === null || chatData === void 0 ? void 0 : chatData.thankYouText,
            responses: {
                "General Questions": "You can find general information here..."
            }
        },
        ar: {
            promptText: chatData === null || chatData === void 0 ? void 0 : chatData.promptText,
            welcome: chatData === null || chatData === void 0 ? void 0 : chatData.welcomeText,
            selectOption: chatData === null || chatData === void 0 ? void 0 : chatData.optionsSelectionText,
            otherResponse: (ref3 = (ref2 = chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories[(chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories.length) - 1]) === null || ref2 === void 0 ? void 0 : ref2.questions[0]) === null || ref3 === void 0 ? void 0 : ref3.description,
            returnPrompt: chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
            fallback: chatData === null || chatData === void 0 ? void 0 : chatData.fallbackText,
            thankYou: chatData === null || chatData === void 0 ? void 0 : chatData.thankYouText,
            responses: {
                "الأسئلة العامة": "يمكنك العثور على المعلومات العامة هنا..."
            }
        },
        zh: {
            promptText: chatData === null || chatData === void 0 ? void 0 : chatData.promptText,
            welcome: chatData === null || chatData === void 0 ? void 0 : chatData.welcomeText,
            selectOption: chatData === null || chatData === void 0 ? void 0 : chatData.optionsSelectionText,
            otherResponse: (ref5 = (ref4 = chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories[(chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories.length) - 1]) === null || ref4 === void 0 ? void 0 : ref4.questions[0]) === null || ref5 === void 0 ? void 0 : ref5.description,
            returnPrompt: chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
            fallback: chatData === null || chatData === void 0 ? void 0 : chatData.fallbackText,
            thankYou: chatData === null || chatData === void 0 ? void 0 : chatData.thankYouText,
            responses: {
                常见问题: "您可以在这里找到常规信息..."
            }
        },
        ko: {
            promptText: chatData === null || chatData === void 0 ? void 0 : chatData.promptText,
            welcome: chatData === null || chatData === void 0 ? void 0 : chatData.welcomeText,
            selectOption: chatData === null || chatData === void 0 ? void 0 : chatData.optionsSelectionText,
            otherResponse: (ref7 = (ref6 = chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories[(chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories.length) - 1]) === null || ref6 === void 0 ? void 0 : ref6.questions[0]) === null || ref7 === void 0 ? void 0 : ref7.description,
            returnPrompt: chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
            fallback: chatData === null || chatData === void 0 ? void 0 : chatData.fallbackText,
            thankYou: chatData === null || chatData === void 0 ? void 0 : chatData.thankYouText,
            responses: {
                "자주 묻는 질문": "여기에서 일반 정보를 찾을 수 있습니다..."
            }
        }
    };
    //   htis is
    // const lang = language || 'ar';
    var t = content[language];
    var services = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var ref;
        var ref1;
        var raw = (ref1 = chatData === null || chatData === void 0 ? void 0 : (ref = chatData.serviceCategories) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.title;
        }).filter(Boolean)) !== null && ref1 !== void 0 ? ref1 : [];
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Map(raw.map(function(title) {
            return [
                title,
                title
            ];
        })).values());
    }, [
        chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories
    ]);
    var getQuestionsForService = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(title) {
        var ref, ref1;
        return ((ref1 = chatData === null || chatData === void 0 ? void 0 : (ref = chatData.serviceCategories) === null || ref === void 0 ? void 0 : ref.find(function(cat) {
            return (cat === null || cat === void 0 ? void 0 : cat.title) === title;
        })) === null || ref1 === void 0 ? void 0 : ref1.questions) || [];
    }, [
        chatData === null || chatData === void 0 ? void 0 : chatData.serviceCategories
    ]);
    var createServiceStep = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(label) {
        var ref;
        var hasQuestions = getQuestionsForService(label).length > 0;
        return hasQuestions ? {
            id: "answer-".concat(label),
            message: (locale == "ar" ? "الإختيار: " : locale == "zh" ? "您选择了：" : locale == "ko" ? "선택한 항목: " : "You selected: ") + "".concat(label),
            trigger: function() {
                setChatAnalyticsPostBody(function(prev) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                        SerivceTitle: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(prev.SerivceTitle).concat([
                            "".concat(label)
                        ]),
                        LastStepName: "".concat(label)
                    });
                });
                return "questions-".concat(label);
            }
        } : {
            id: "answer-".concat(label),
            message: ((ref = t.responses) === null || ref === void 0 ? void 0 : ref[label]) || t.otherResponse,
            trigger: "returnOrEnd"
        };
    }, // Do not depend on `t.responses` (new object every render); `chatData` covers CMS updates.
    [
        getQuestionsForService,
        locale,
        setChatAnalyticsPostBody,
        t.otherResponse,
        chatData
    ]);
    var createQuestionSteps = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(serviceTitle) {
        var raw = getQuestionsForService(serviceTitle);
        var seen = new Set();
        var questions = raw.filter(function(q) {
            var key = "".concat(((q === null || q === void 0 ? void 0 : q.title) || "").trim(), "|").concat(((q === null || q === void 0 ? void 0 : q.description) || "").slice(0, 80));
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        if (!questions.length) return [];
        return [
            {
                id: "questions-".concat(serviceTitle),
                message: t.selectOption,
                trigger: function() {
                    return "question-options-".concat(serviceTitle);
                }
            },
            {
                id: "question-options-".concat(serviceTitle),
                options: questions.map(function(q, i) {
                    return {
                        value: q.title || "q".concat(i),
                        label: q.title || "Question ".concat(i + 1),
                        trigger: function() {
                            return "question-answer-".concat(serviceTitle, "-").concat(i);
                        }
                    };
                })
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(questions.map(function(q, i) {
            return {
                id: "question-answer-".concat(serviceTitle, "-").concat(i),
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_12__/* .RichText */ .H, {
                        field: {
                            value: q.description
                        }
                    })
                }),
                asMessage: true,
                trigger: function() {
                    setChatAnalyticsPostBody(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                            LastStepName: "".concat(q.title),
                            ServiceQuestion: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(prev.ServiceQuestion).concat([
                                "question-".concat(q.title, "--answer-").concat(q.description), 
                            ])
                        });
                    });
                    return "returnOrEnd";
                }
            };
        })));
    }, [
        getQuestionsForService,
        setChatAnalyticsPostBody,
        t.selectOption
    ]);
    var serviceOptions = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return services.map(function(label) {
            return {
                value: label,
                label: label,
                trigger: function() {
                    setChatAnalyticsPostBody(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                            LastStepName: "".concat(label)
                        });
                    });
                    return label === "Other" || label === "أخرى" ? "otherAnswer" : "answer-".concat(label);
                }
            };
        });
    }, [
        services,
        setChatAnalyticsPostBody
    ]);
    var RatingComp = function(param) {
        var previousStep = param.previousStep;
        var emojis = [
            "\uD83D\uDE21",
            "\uD83D\uDE15",
            "\uD83D\uDE10",
            "\uD83D\uDE0A",
            "\uD83E\uDD29"
        ];
        var ratingText = {
            1: chatData === null || chatData === void 0 ? void 0 : chatData.fifthRating,
            2: chatData === null || chatData === void 0 ? void 0 : chatData.fourthRating,
            3: chatData === null || chatData === void 0 ? void 0 : chatData.thirdRating,
            4: chatData === null || chatData === void 0 ? void 0 : chatData.secondRating,
            5: chatData === null || chatData === void 0 ? void 0 : chatData.firstRating
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: ratingText[previousStep === null || previousStep === void 0 ? void 0 : previousStep.value]
                }),
                !(chatData === null || chatData === void 0 ? void 0 : chatData.showIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: emojis[(previousStep === null || previousStep === void 0 ? void 0 : previousStep.value) - 1]
                })
            ]
        });
    };
    var steps = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return [
            {
                id: "intro",
                message: t.promptText,
                trigger: "welcome"
            },
            {
                id: "welcome",
                message: function() {
                    return t.welcome;
                },
                trigger: function() {
                    setChatAnalyticsPostBody(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                            LastStepName: "Initial"
                        });
                    });
                    return "select-service";
                }
            },
            {
                id: "select-service",
                message: function() {
                    return t.selectOption;
                },
                trigger: function() {
                    return "service-options";
                }
            },
            {
                id: "service-options",
                options: serviceOptions
            }, 
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(services.filter(function(label) {
            return label !== "Other" && label !== "أخرى";
        }).flatMap(function(label) {
            return [
                createServiceStep(label)
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(createQuestionSteps(label)));
        })), [
            {
                id: "otherAnswer",
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_12__/* .RichText */ .H, {
                        field: {
                            value: t.otherResponse
                        }
                    })
                }),
                asMessage: true,
                trigger: "returnOrEnd"
            },
            {
                id: "returnOrEnd",
                options: [
                    {
                        value: 1,
                        label: chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
                        trigger: function() {
                            setChatAnalyticsPostBody(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                                    LastStepName: "".concat(chatData === null || chatData === void 0 ? void 0 : chatData.restartText)
                                });
                            });
                            return "select-service";
                        }
                    },
                    {
                        value: 2,
                        label: chatData === null || chatData === void 0 ? void 0 : chatData.endText,
                        trigger: function() {
                            setChatAnalyticsPostBody(function(prev) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                                    LastStepName: "".concat(chatData === null || chatData === void 0 ? void 0 : chatData.endText)
                                });
                            });
                            return "feedback";
                        }
                    }, 
                ]
            },
            {
                id: "return-check",
                user: true,
                trigger: function(value) {
                    return value.value === "0" ? "select-service" : "feedback";
                }
            },
            {
                id: "fallback",
                message: function() {
                    return t.fallback;
                },
                trigger: "returnOrEnd"
            },
            {
                id: "feedback",
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StarRating, {}),
                waitAction: true,
                asMessage: true,
                trigger: "rating-response"
            },
            {
                id: "rating-response",
                component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RatingComp, {}),
                asMessage: true,
                trigger: "goodbye"
            },
            {
                id: "goodbye",
                message: function() {
                    return t.thankYou;
                },
                end: true
            }, 
        ]);
    }, [
        chatData === null || chatData === void 0 ? void 0 : chatData.endText,
        chatData === null || chatData === void 0 ? void 0 : chatData.restartText,
        createQuestionSteps,
        createServiceStep,
        serviceOptions,
        services,
        setChatAnalyticsPostBody,
        t.fallback,
        t.otherResponse,
        t.promptText,
        t.selectOption,
        t.thankYou,
        t.welcome, 
    ]);
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isFirstRender = ref13[0], setIsFirstRender = ref13[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isFirstRender && isOpen) {
            setIsFirstRender(false);
        }
    }, [
        isOpen
    ]);
    // COMMENTED OUT: Location tracking code for privacy
    // get user country without permission serverside
    // useEffect(() => {
    //   if (isFirstRender && isOpen) {
    //     setIsFirstRender(false);
    //     const fetchLocation = async () => {
    //       try {
    //         // user request own api
    //         //try getting it with https://api.ipify.org?format=json
    //         const ipifyResponse = await fetch("https://api.ipify.org?format=json");
    //         // if (ipifyResponse.ok) {
    //         const ipifyData = await ipifyResponse.json();
    //         const userProvidedIP = ipifyData.ip;
    //         // }
    //         // }
    //         // const res = await fetch("/api/ip-address/ipLocation");
    //         const res = await axios.post("/api/ip-address/ipLocation", {
    //           userProvidedIP: userProvidedIP || null,
    //         });
    //         // const data = await res.json();
    //         if (res?.data?.success && res?.data.country) {
    //           setChatAnalyticsPostBody((prev) => ({
    //             ...prev,
    //             Location: res?.data.country,
    //           }));
    //         } else {
    //           console.warn("Could not get country info from API:", res?.data);
    //           // Ask for browser geolocation permission
    //           if ("geolocation" in navigator) {
    //             navigator.geolocation.getCurrentPosition(
    //               async (position) => {
    //                 const { latitude, longitude } = position.coords;
    //                 //api.bigdatacloud.net/data/reverse-geocode-client?latitude=45.4215&longitude=-75.6972&localityLanguage=en
    //                 // get country from lat/lng
    //                 const res = await fetch(
    //                   `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
    //                 );
    //                 const data = await res.json();
    //                 const country = data?.countryName;
    //                 // You can reverse geocode this lat/lng to country using some API or logic
    //                 // Or just store lat/lng for analytics
    //                 setChatAnalyticsPostBody((prev) => ({
    //                   ...prev,
    //                   Location: country,
    //                 }));
    //               },
    //               (error) => {
    //                 console.error("User denied geolocation or error:", error);
    //                 setChatAnalyticsPostBody((prev) => ({
    //                   ...prev,
    //                   Location: error?.code === 1 ? error?.message : "LAT/LNG to Country API Failed",
    //                 }));
    //               }
    //             );
    //           } else {
    //             console.warn("Geolocation not supported in this browser");
    //           }
    //         }
    //       } catch (error) {
    //         console.error("Failed to fetch location info:", error);
    //       }
    //     };
    //     fetchLocation();
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isOpen]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!isFirstRender || !isOpen) return;
        var storageKey = "moc_chatbot_analytics_session_id";
        try {
            var sessionId = sessionStorage.getItem(storageKey);
            if (!sessionId) {
                sessionId = typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 11));
                sessionStorage.setItem(storageKey, sessionId);
            }
            setChatAnalyticsPostBody(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                    SessionId: sessionId,
                    Language: locale
                });
            });
        } catch (e) {
            var sessionId1 = typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 11));
            setChatAnalyticsPostBody(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prev), {
                    SessionId: sessionId1,
                    Language: locale
                });
            });
        }
    }, [
        isOpen,
        isFirstRender,
        locale
    ]);
    var toggleChatbot = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setIsOpen(function(prev) {
            if (prev) {
                void axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat("https://c-admin.takamulstg.com", "/api/Chatbot/submissions"), chatAnalyticsRef.current, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).catch(function(_error) {
                // Drop-off analytics — ignore failures
                });
            }
            return !prev;
        });
    }, []);
    var handleEnd = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(param) {
        var values = param.values;
        var filteredValues = values.filter(function(item, index) {
            if (typeof item === "string" || index === values.length - 1) {
                return item;
            } else {
                return null;
            }
        });
        var filteredServices = filteredValues.filter(function(item, index) {
            if (typeof item === "string" && index % 2 == 0) {
                return item;
            } else {
                return null;
            }
        });
        var filteredQuestions = filteredValues.filter(function(item, index) {
            if (typeof item === "string" && index % 2 != 0) {
                return item;
            } else {
                return null;
            }
        });
        axios__WEBPACK_IMPORTED_MODULE_1___default().post("".concat("https://c-admin.takamulstg.com", "/api/Chatbot/submissions"), {
            SerivceTitle: filteredServices,
            ServiceQuestion: filteredQuestions,
            Rating: filteredValues[filteredValues.length - 1],
            Language: locale,
            SessionId: chatAnalyticsRef.current.SessionId,
            LastStepName: filteredValues[filteredValues.length - 2] || ""
        }, {
            headers: {
                "Content-Type": "application/json"
            }
        }).catch(function(error) {
            console.error("Submission error:", error);
        });
        setTimeout(function() {
            setIsOpen(true);
        }, 4000);
    }, [
        locale
    ]);
    var theme = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return {
            background: "#fff",
            headerBgColor: "#1B8354",
            headerFontColor: "#fffff",
            headerFontSize: "15px",
            botBubbleColor: "#E5E7EB",
            botFontColor: "#fff",
            userBubbleColor: "#eee",
            userFontColor: "#000"
        };
    }, []);
    var chatHeader = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChatHeader, {
            toggleChatbot: toggleChatbot,
            header: chatData === null || chatData === void 0 ? void 0 : chatData.chatBotTitle,
            online: chatData === null || chatData === void 0 ? void 0 : chatData.onlineText
        });
    }, [
        toggleChatbot,
        chatData === null || chatData === void 0 ? void 0 : chatData.chatBotTitle,
        chatData === null || chatData === void 0 ? void 0 : chatData.onlineText
    ]);
    var chatNavLabel = locale === "ar" ? "الدردشة والمساعدة" : locale === "zh" ? "聊天和帮助" : locale === "ko" ? "채팅 및 도움말" : "Chat and help";
    return !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_components__WEBPACK_IMPORTED_MODULE_13__.ThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
            "aria-label": chatNavLabel,
            className: " fixed bottom-5 ".concat(!isRtl ? "right-5" : "right-5", " z-[500] flex flex-col items-end gap-2"),
            children: [
                isOpen && !loading && chatBotLoaded && ChatBot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChatBot, {
                    steps: steps,
                    headerComponent: chatHeader,
                    avatar: true,
                    botAvatar: null,
                    userAvatar: null,
                    hideBotAvatar: true,
                    hideUserAvatar: true,
                    botDelay: 500,
                    userDelay: 300,
                    placeholder: locale === "ar" ? "إرسال" : locale === "ko" ? "메시지" : locale === "zh" ? "留言" : "Message",
                    recognitionEnable: false,
                    handleEnd: handleEnd,
                    floating: true
                }),
                !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    "aria-expanded": isOpen,
                    "aria-haspopup": "dialog",
                    "aria-label": locale === "ar" ? isOpen ? "إغلاق نافذة الدردشة" : "فتح نافذة الدردشة" : locale === "zh" ? isOpen ? "关闭聊天" : "打开聊天" : locale === "ko" ? isOpen ? "채팅 닫기" : "채팅 열기" : isOpen ? "Close chat" : "Open chat",
                    className: "cursor-pointer p-4 bg-[#1B8354] hover:bg-primary-700 active:bg-primary-800 z-50 rounded-full border-0",
                    onClick: toggleChatbot,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 22 22",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "aria-hidden": true,
                        focusable: "false",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M2.81802 19.637C3.21502 19.71 3.61599 19.746 4.01699 19.746L4.01802 19.7471C5.10002 19.7471 6.17601 19.4851 7.13501 18.9761L7.23398 18.925L7.26221 18.9106C7.42408 18.8283 7.58602 18.7458 7.67202 18.709C7.70802 18.713 7.76801 18.72 7.86201 18.738C8.27001 18.814 8.66099 18.5461 8.73799 18.1391C8.81399 17.7321 8.54601 17.34 8.13901 17.263C7.86001 17.211 7.66298 17.1961 7.47998 17.2141C7.45398 17.2171 7.42698 17.2211 7.40098 17.2261C7.16998 17.2741 6.96398 17.3791 6.55298 17.5891L6.44902 17.642L6.43799 17.648C5.76299 18.007 5.013 18.208 4.252 18.242C4.447 17.828 4.591 17.387 4.679 16.929C4.806 16.254 4.55998 15.545 4.00298 14.982C2.55098 13.522 1.752 11.615 1.752 9.61104C1.752 5.27704 5.48801 1.75107 10.081 1.75107C14.085 1.75107 17.527 4.44107 18.266 8.14707C18.347 8.55307 18.741 8.81503 19.148 8.73604C19.554 8.65504 19.818 8.26 19.737 7.854C18.859 3.448 14.798 0.25 10.08 0.25C4.65998 0.25 0.250977 4.44906 0.250977 9.61006C0.250977 12.0121 1.20499 14.296 2.93599 16.037C3.03299 16.135 3.252 16.39 3.204 16.648C3.077 17.307 2.79098 17.92 2.37598 18.421C2.20598 18.626 2.15802 18.9061 2.24902 19.1561C2.33902 19.4061 2.55602 19.589 2.81802 19.637Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M17.143 21.242C17.7679 21.5769 18.4657 21.7499 19.1675 21.75C19.4313 21.75 19.6952 21.725 19.956 21.6761C20.216 21.6271 20.43 21.4451 20.521 21.1971C20.611 20.9491 20.565 20.671 20.398 20.466C20.173 20.19 20.024 19.87 19.956 19.517C19.96 19.499 19.981 19.452 20.029 19.405L20.038 19.396C21.141 18.277 21.749 16.808 21.749 15.259C21.749 11.945 18.945 9.24902 15.499 9.24902C12.053 9.24902 9.24902 11.945 9.24902 15.259C9.24902 18.573 12.053 21.269 15.499 21.269C15.917 21.269 16.319 21.231 16.695 21.157C16.7105 21.1545 16.7256 21.1521 16.7403 21.1497C16.772 21.1446 16.8017 21.1398 16.829 21.1351C16.855 21.1311 16.885 21.1261 16.911 21.1221C16.955 21.1441 17.013 21.1741 17.066 21.2021L17.143 21.242ZM17.761 19.8721C17.52 19.7461 17.355 19.66 17.157 19.629C16.96 19.593 16.784 19.6221 16.582 19.6561C16.5507 19.6615 16.5164 19.667 16.4791 19.6729C16.4686 19.6746 16.458 19.6763 16.447 19.678C16.437 19.679 16.427 19.681 16.417 19.683C16.133 19.74 15.825 19.769 15.5 19.769C12.881 19.769 10.75 17.746 10.75 15.259C10.75 12.772 12.881 10.749 15.5 10.749C18.119 10.749 20.25 12.772 20.25 15.259C20.25 16.409 19.797 17.502 18.975 18.338C18.57 18.738 18.386 19.279 18.482 19.788C18.507 19.923 18.541 20.056 18.581 20.187C18.327 20.133 18.08 20.0421 17.849 19.9181C17.846 19.9161 17.84 19.913 17.84 19.913L17.761 19.8721Z",
                                fill: "white"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ChatBotComponent);


/***/ }),

/***/ 82395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Checkbox": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_check__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54472);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16606);






var Checkbox = function(_param) {
    var label = _param.label, labelClassName = _param.labelClassName, labelTextClassName = _param.labelTextClassName, checkboxClassName = _param.checkboxClassName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "labelClassName",
        "labelTextClassName",
        "checkboxClassName"
    ]);
    if (!label) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "inline-flex items-center gap-2 cursor-pointer select-none ".concat(labelClassName && labelClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                type: "checkbox",
                className: "peer sr-only"
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "[&>svg]:hidden [&>svg]:peer-checked:block w-5 h-5 rounded-[7px] border border-neutral-300 peer-checked:border-black flex items-center justify-center transition-colors duration-75 ".concat(checkboxClassName && checkboxClassName),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_check__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    "aria-label": "",
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .RichText */ .H, {
                field: {
                    value: label
                },
                className: "text-sm text-[#333333] font-medium ".concat(labelTextClassName && labelTextClassName)
            })
        ]
    });
};


/***/ }),

/***/ 52014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomPlayer": function() { return /* binding */ CustomPlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62642);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__);




gsap__WEBPACK_IMPORTED_MODULE_2__["default"].registerPlugin(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__.ScrollTrigger);
var CustomPlayer = function(param) {
    var src = param.src, poster = param.poster, title = param.title, description = param.description, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? true : _isCentered, locale = param.locale, lang = param.lang;
    var pauseRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var playRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var cursorRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var videoInterval = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), videoTime = ref[0], setVideoTime = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currentTime = ref1[0], setCurrentTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setMounted(true);
        gsap__WEBPACK_IMPORTED_MODULE_2__["default"].set(".animate-top", {
            opacity: 0,
            y: 100
        });
        gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__.ScrollTrigger.batch(".animate-top", {
            onEnter: function(batch) {
                return gsap__WEBPACK_IMPORTED_MODULE_2__["default"].to(batch, {
                    opacity: 1,
                    y: 0,
                    stagger: {
                        each: 0.2
                    },
                    overwrite: true
                });
            },
            onEnterBack: function(batch) {
                return gsap__WEBPACK_IMPORTED_MODULE_2__["default"].to(batch, {
                    opacity: 1,
                    y: 0,
                    stagger: 0.2,
                    overwrite: true
                });
            }
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative w-full v-md:w-[47%] h-full aspect-[1.63] animate-top group",
        onDoubleClick: function() {
            return videoRef.current.requestFullscreen();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                className: "w-full h-full object-cover",
                ref: videoRef,
                src: src,
                poster: poster,
                preload: false,
                "aria-label": title || "Video player",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("track", {
                    kind: "captions"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "controls absolute bottom-0 w-full p-6 gap-4 hidden",
                ref: playRef,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        onClick: function() {
                            playRef.current.classList.add("hidden");
                            playRef.current.classList.remove("flex");
                            pauseRef.current.classList.remove("hidden");
                            videoRef.current.pause();
                            clearInterval(videoInterval.current);
                        },
                        alt: "",
                        src: "/pausebutton.svg",
                        "aria-hidden": "true",
                        className: "pauseButton w-[25%] min-w-[60px] max-w-[70px] aspect-square hover:cursor-pointer"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative w-full flex justify-between h-0.5 rounded-full self-center hover:cursor-pointer bg-white text-white",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute h-2.5 w-2.5 rounded-full -translate-y-2/4 bg-white",
                                ref: cursorRef
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    " ",
                                    ~~(currentTime / 60) + ":" + ("0" + ~~(currentTime % 60)).slice(-2)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    " ",
                                    ~~(videoTime / 60) + ":" + ("0" + ~~(videoTime % 60)).slice(-2)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "controls absolute flex bottom-0 w-full p-6 pr-4 \n        bg-gradient-to-t from-[#0000009d] lg:opacity-0 lg:group-hover:opacity-100 transition-all duration-500\n        ".concat(isCentered ? "justify-between " : "top-0 justify-center items-center"),
                ref: pauseRef,
                children: [
                    isCentered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " flex flex-col gap-y-4 ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: " text-4brand md:text-[30px] 2xl:text-3brand text-white font-medium ",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: " text-white pr-4 text-5brand 2xl:text-4brand",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        onClick: function() {
                            playRef.current.classList.remove("hidden");
                            playRef.current.classList.add("flex");
                            pauseRef.current.classList.add("hidden");
                            videoRef.current.play();
                            setVideoTime(videoRef.current.duration);
                            videoInterval.current = mounted && window.setInterval(function() {
                                var ref, ref1, ref2;
                                setCurrentTime((ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.currentTime);
                                var duration = (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.duration;
                                var current = (ref2 = videoRef.current) === null || ref2 === void 0 ? void 0 : ref2.currentTime;
                                if (cursorRef.current) {
                                    cursorRef.current.style.left = current / duration * 100 + "%";
                                } else {
                                    clearInterval(videoInterval.current);
                                }
                            }, 1000);
                        },
                        alt: "",
                        src: "/playbutton.svg",
                        "aria-hidden": "true",
                        className: "playbutton w-[25%] min-w-[60px] max-w-[70px]\n           aspect-square hover:cursor-pointer ".concat(isCentered ? "self-end" : "")
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);